import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/** Возвращает коофициент, влияющий на то, насколько большая зона будет во втором(четном) запросе за пинами. */
export var getFetchRatio = function getFetchRatio(options) {
  return options.fetchCoefficient * (options.currentZoom / options.minZoom);
};

/** Возвращает данные необходимые клиенту для запроса за данными для большой зоны(вторые или четные запросы) */
export var getDataForHugeFetch = function getDataForHugeFetch(options) {
  var fetchCoefficient = options.fetchCoefficient,
    data = options.data,
    minZoom = options.minZoom,
    geoObjectNames = options.geoObjectNames;
  var zoom = data.zoom,
    center = data.center;
  var bbox = data.bbox;
  var fetchRatio = getFetchRatio({
    fetchCoefficient: fetchCoefficient,
    currentZoom: zoom,
    minZoom: minZoom
  });
  var bboxWidth = bbox.topLeft.lng - bbox.bottomRight.lng;
  var bboxMultipliedWidth = bboxWidth * fetchRatio;
  var bboxHeight = bbox.bottomRight.lat - bbox.topLeft.lat;
  var bboxMultipliedHeight = bboxHeight * fetchRatio;
  bbox = {
    topLeft: {
      lng: bbox.topLeft.lng + bboxMultipliedWidth,
      lat: bbox.topLeft.lat - bboxMultipliedHeight
    },
    bottomRight: {
      lng: bbox.bottomRight.lng - bboxMultipliedWidth,
      lat: bbox.bottomRight.lat - bboxMultipliedHeight
    }
  };
  return {
    zoom: zoom,
    bbox: bbox,
    center: center,
    geoObjectNames: geoObjectNames
  };
};

/** Возвращает данные необходимые клиенту для запроса за данными */
export var getFetchData = function getFetchData(options) {
  return _objectSpread(_objectSpread({}, options.data), {}, {
    geoObjectNames: options.geoObjectNames
  });
};